import React from 'react'

import { FormItem } from '@react/react-spectrum/Form'
import Heading from '@react/react-spectrum/Heading'
import Textfield from '@react/react-spectrum/Textfield'

import ColorInput from 'components/ColorInput'
import MediaUpload from 'components/MediaUpload'
import PlainTextEditor from 'components/PlainTextEditor'
import Select from '@react/react-spectrum/Select'

const THEME_OPTIONS = [
  { label: 'None', value: '' },
  { label: 'Bodea', value: 'bodea' },
  { label: 'Carvelo', value: 'carvelo' },
  { label: 'Customer Hub', value: 'customer-hub' },
  { label: 'Fréscopa', value: 'frescopa' },
  { label: 'Luma', value: 'luma' },
  { label: 'SecurFinancial', value: 'securfinancial' },
  { label: 'we.Healthcare', value: 'we-healthcare' },
  { label: 'WKND Fly', value: 'wknd-fly' },
]

export default function WebModularBrandingForm({ branding, project, disabled, onChange }) {
  const customStylesheet = branding.customStylesheet
    ?.replaceAll(/(\{\s*)/g, '{\n  ')
    .replaceAll(/( *);( *)/g, ';\n  ')
    .replaceAll(/(\s*)\}(\s*)/g, '\n}\n')
    .replaceAll(/ {2,}/g, '  ')
  const updateStylesheet = (v) => onChange('customStylesheet')(v.replaceAll('\n', '').replaceAll(/\s{2,}/g, ' '))

  return (
    <>
      <section>
        <Heading size='4'>Main Logo</Heading>

        <MediaUpload
          type='image'
          value={branding.logo}
          heading='Drag and Drop'
          onUpload={onChange('logo')}
          projectId={project?.meta?.id}
          path={'branding-logo'}
          withTextfield={true}
          disabled={disabled}
        />
        <Heading size='4'>Footer Logo</Heading>

        <MediaUpload
          type='image'
          value={branding.footerLogo}
          heading='Drag and Drop'
          onUpload={onChange('footerLogo')}
          projectId={project?.meta?.id}
          path={'branding-footerLogo'}
          withTextfield={true}
          disabled={disabled}
        />
        <Heading size='4'>Bot Icon</Heading>

        <MediaUpload
          type='image'
          value={branding.botIcon}
          heading='Drag and Drop'
          onUpload={onChange('botIcon')}
          projectId={project?.meta?.id}
          path={'branding-botIcon'}
          withTextfield={true}
          disabled={disabled}
        />
      </section>

      <section>
        <Heading size='4'>Colors</Heading>

        <FormItem label='Primary'>
          <ColorInput
            name='primaryColor'
            value={branding.primaryColor}
            onChange={onChange('primaryColor')}
            disabled={disabled}
          />
        </FormItem>

        <FormItem label='Secondary'>
          <ColorInput
            name='secondaryColor'
            value={branding.secondaryColor}
            onChange={onChange('secondaryColor')}
            disabled={disabled}
          />
        </FormItem>

        <FormItem label='Body Background'>
          <ColorInput
            name='backgroundColor'
            value={branding.backgroundColor}
            onChange={onChange('backgroundColor')}
            disabled={disabled}
          />
        </FormItem>

        <FormItem label='Body Text'>
          <ColorInput
            name='primaryTextColor'
            value={branding.primaryTextColor}
            onChange={onChange('primaryTextColor')}
            disabled={disabled}
          />
        </FormItem>

        <FormItem label='Header Background'>
          <ColorInput
            name='headerBackgroundColor'
            value={branding.headerBackgroundColor}
            onChange={onChange('headerBackgroundColor')}
            disabled={disabled}
          />
        </FormItem>

        <FormItem label='Header Text'>
          <ColorInput
            name='headerTextColor'
            value={branding.headerTextColor}
            onChange={onChange('headerTextColor')}
            disabled={disabled}
          />
        </FormItem>

        <FormItem label='Footer Background'>
          <ColorInput
            name='footerBackgroundColor'
            value={branding.footerBackgroundColor}
            onChange={onChange('footerBackgroundColor')}
            disabled={disabled}
          />
        </FormItem>

        <FormItem label='Footer Text'>
          <ColorInput
            name='footerTextColor'
            value={branding.footerTextColor}
            onChange={onChange('footerTextColor')}
            disabled={disabled}
          />
        </FormItem>
      </section>

      <section>
        <Heading size='4'>Fonts & Other</Heading>

        <FormItem label='Adobe Fonts project ID'>
          <Textfield
            name='fontsProjectId'
            value={branding.fontsProjectId}
            onChange={onChange('fontsProjectId')}
            disabled={disabled}
          />
        </FormItem>

        <FormItem label='Body Font'>
          <Textfield name='bodyFont' value={branding.bodyFont} onChange={onChange('bodyFont')} disabled={disabled} />
        </FormItem>

        <FormItem label='Heading Font'>
          <Textfield
            name='headingFont'
            value={branding.headingFont}
            onChange={onChange('headingFont')}
            disabled={disabled}
          />
        </FormItem>

        <FormItem label='Border Radius'>
          <Textfield
            name='borderRadius'
            value={branding.borderRadius || ''}
            onChange={onChange('borderRadius')}
            disabled={disabled}
          />
        </FormItem>

        <Heading size='4'>Additional Styles</Heading>

        <FormItem label='Theme'>
          <Select
            value={branding.theme || ''}
            options={THEME_OPTIONS}
            disabled={disabled}
            onChange={onChange('theme')}
          />
        </FormItem>

        <PlainTextEditor
          buttonLabel='Custom CSS'
          name='customStylesheet'
          defaultValue={customStylesheet}
          disabled={disabled}
          onChange={updateStylesheet}
        />
      </section>
    </>
  )
}
